module.exports = __webpack_public_path__ + "media/images/placeholder-competition-questions-49fae37e.png";